import { Component, OnInit, forwardRef, ElementRef, SimpleChanges, EventEmitter, Input, Output } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

declare var $: any;

@Component({
  selector: 'lib-datepicker-lib',
  template: `
  <div class="fieldset">
  <input type="text" bsDatepicker
         [placement]="m_placement"
         [tabindex]="p_tabindex"
         [name]="p_name"
         [placeholder]="p_placeholder"
         [disabled]="disableController"
         [minDate]="p_min_date"
         [maxDate]="p_max_date"
         [bsConfig]="{ dateInputFormat: m_date_format, containerClass: 'theme-dark-blue' }"
         [(ngModel)]="calendarValue"
         (ngModelChange)="onValueChange()"
         (onShown)="SetCalendarPlacement()">
</div> 
  `,
  styles: [],
  providers: [
    { provide: ControlContainer, useExisting: forwardRef(() => DatepickerLibComponent) },
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => DatepickerLibComponent), multi: true }
  ]
})
export class DatepickerLibComponent implements OnInit, ControlValueAccessor {
  @Input() p_container_id: string = "";
  @Input() p_tabindex: number = 0;
  @Input() p_name: string = "";
  @Input() p_placeholder: string = "";
  @Input() p_min_date: Date = null;
  @Input() p_max_date: Date = null;

  @Input('calendarValue') _calendarValue: any;
  @Output('change') change = new EventEmitter<Date>();
  disableController: Boolean = false;
  propagateChange: any = () => { };

  get calendarValue() {
    return this._calendarValue;
  }

  set calendarValue(val) {
    this._calendarValue = val;
    this.propagateChange(val);
  }

  writeValue(value: any): void {
    if (value !== undefined) {
      this.calendarValue = value;
    }
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {

  }

  setDisabledState?(isDisabled: boolean): void {
    this.disableController = isDisabled;
  }

  public m_date_format: string = "DD/MM/YYYY";

  public m_placement: string = "bottom";

  constructor(
    private elmRef: ElementRef
  ) { }

  ngOnInit() {
    this.SetCalendarPlacement();
  }

  ngOnChanges(changes: SimpleChanges) {
    // if (this.p_min_date != null && this.p_max_date == null) {
    //     this.p_max_date = new Date(this.p_min_date.getFullYear() + 100, 1, 1);
    // }
    // else if (this.p_min_date == null && this.p_max_date != null) {
    //     this.p_min_date = new Date(this.p_max_date.getFullYear() - 100, 1, 1);
    // }

    if (changes["p_min_date"] != undefined && changes["p_min_date"]["currentValue"] != undefined) {
      this.p_min_date = new Date(changes["p_min_date"]["currentValue"]);
    }

    if (changes["p_max_date"] != undefined && changes["p_max_date"]["currentValue"] != undefined) {
      this.p_max_date = new Date(changes["p_max_date"]["currentValue"]);
    }

    if (this.p_min_date != null && this.p_max_date == null) {
      this.p_min_date = new Date(this.p_min_date);
      this.p_max_date = new Date(new Date(this.p_min_date).getFullYear() + 100, 1, 1);
    }
    else if (this.p_min_date == null && this.p_max_date != null) {
      this.p_max_date = new Date(this.p_max_date);
      this.p_min_date = new Date(new Date(this.p_max_date).getFullYear() - 100, 1, 1);
    }

  }

  onValueChange() {
    this.change.emit(this._calendarValue);
  }

  SetCalendarPlacement() {
    let calendar_height = 300;

    if ($("body").find('.bs-datepicker').length > 0) {
      calendar_height = $("body").find('.bs-datepicker').first().height();
    }

    if ($("body").height() - $(this.elmRef.nativeElement).find('.fieldset').first().offset().top < calendar_height) {
      this.m_placement = "top";
    }
    else {
      this.m_placement = "bottom";
    }
  }

}
